import { render, staticRenderFns } from "./add.vue?vue&type=template&id=2cb817b7&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=2cb817b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb817b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb817b7')) {
      api.createRecord('2cb817b7', component.options)
    } else {
      api.reload('2cb817b7', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=2cb817b7&scoped=true&", function () {
      api.rerender('2cb817b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/soundWall/add.vue"
export default component.exports